var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.07.167C9.29.167 11.903 2.78 11.903 6S9.29 11.833 6.07 11.833A5.835 5.835 0 01.237 6 5.835 5.835 0 016.07.167zm0 .875A4.96 4.96 0 001.112 6a4.96 4.96 0 004.958 4.958A4.96 4.96 0 0011.028 6 4.96 4.96 0 006.07 1.042zm0 4.083c.322 0 .583.261.583.583v2.625a.583.583 0 11-1.166 0V5.708c0-.322.26-.583.583-.583zm0-2.042a.656.656 0 110 1.313.656.656 0 010-1.313z"
  })));
}

export default SvgIconInfo;